module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('flow', [_c('flow-state', {
    attrs: {
      "state": "1",
      "title": "填写信息",
      "is-done": ""
    }
  }), _vm._v(" "), _c('flow-line', {
    attrs: {
      "is-done": ""
    }
  }), _vm._v(" "), _c('flow-state', {
    attrs: {
      "state": "3",
      "title": "支付保证金",
      "is-done": ""
    }
  }), _vm._v(" "), _c('flow-line', {
    attrs: {
      "is-done": ""
    }
  }), _vm._v(" "), _c('flow-state', {
    attrs: {
      "state": "3",
      "title": "申请完成",
      "is-done": ""
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px",
      "padding": "10px"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("充库存")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("申请完成")]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("您的操作已经完成，请前往个人中心充库存。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b0b7c6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sellerRequest/step3.vue
// module id = 654
// module chunks = 0